/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_BadgeInputs */

const en_landing_pricing_compare_badge = /** @type {(inputs: Landing_Pricing_Compare_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dofollow via badge backlink`)
};

const zh_landing_pricing_compare_badge = /** @type {(inputs: Landing_Pricing_Compare_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`徽章回链解锁 Dofollow`)
};

/**
* | output |
* | --- |
* | "Dofollow via badge backlink" |
*
* @param {Landing_Pricing_Compare_BadgeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_badge = /** @type {((inputs?: Landing_Pricing_Compare_BadgeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_BadgeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_badge(inputs)
	return zh_landing_pricing_compare_badge(inputs)
});
export { landing_pricing_compare_badge as "landing.pricing.compare_badge" }